/* eslint-disable max-len */
import React, { useEffect, useState, useLayoutEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CardHeaders from '../../components/CardHeaders'
import LoadingOverlay from "react-loading-overlay-ts";
import { Tooltip } from 'react-tooltip'
import Button from '../../components/Button';
import { dataService } from "../../services/data.services";
import ModalBox from "../OrdersAndPurchase/ViewOrders/Components/CustomModal";
import Pagination from "../../components/Pagination";
import GlobalContext from "../../components/Context/GlobalContext";
import EmptyPage from "../OrdersAndPurchase/components/EmptyPage";
import { checkPrivilege } from "../../CommonMethods/checkPrivilege";
export default function ViewSettlement() {
    const [dataLoading, setDataLoading] = useState(false)
    const [item, setItem] = useState('')
    const [details, setDetails] = useState();
    const [transactionDetails, setTransactionDetails] = useState()
    const { cycleId } = useParams();
    const [modal, setModal] = useState(false);
    const [modalpopup, setmodalpopup] = useState({})
    const [emailAddress, setEmailAddress] = useState('')
    const [note, setNote] = useState('');
    const [status, setStatus] = useState('');
    const [staticStatus, setStaticStatus] = useState('');
    const [noteError, setNoteError] = useState('');
    const [page, setpage] = useState('1')
    const [totalCount, settotalCount] = useState();
    const [exportloading, setExportloading] = useState(false)
    const { setToastmessage, setToastError } = useContext(GlobalContext);
    const navigate = useNavigate()
    const [updateLoading,setUpdateLoading] = useState(false)

    const convertToDate = (timestamp) => {
        // Format the date in the desired format
        return new Date(timestamp * 1000).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
    }
    /**
     * The function `getSettlementdetails` fetches settlement details and transaction data from an API
     * using async/await syntax in a React application.
     */
    // const getTransactions = async () => {
    //     const transactions = await dataService.GetAPI(`orders/list?store_email_address=${emailAddress}&payment_status=Completed`)
    //     setTransactionDetails(transactions?.data?.data)
    // }
    /**
     * The function `getSettlementdetails` fetches settlement details and transaction data based on a
     * given cycle ID.
     */
    const getSettlementdetails = async () => {
        try {
            setDataLoading(true)
            const response = await dataService.GetAPI(`settlements/${cycleId}`)
            setEmailAddress(encodeURIComponent(response?.data?.data?.store_email_address));
            let store_email_address = encodeURIComponent(response?.data?.data?.store_email_address);
            const transactions = await dataService.GetAPI(`orders/list?settlements=true&store_email_address=${store_email_address}&payment_status=Completed&page_number=${page}&create_start=${response?.data?.data?.cycle_start_date}&create_end=${response?.data?.data?.cycle_end_date}`)
            setTransactionDetails(transactions?.data?.data)
            setDetails(response?.data?.data)
            settotalCount(transactions?.data?.total_count)
            setStatus(response?.data?.data?.status)
            setStaticStatus(response?.data?.data?.status)
            setDataLoading(false)
        } catch (error) {
            setDataLoading(false)
            setToastError('Settlement cycle not found')
            navigate('/settlements')
        }
    }
    const handleOnClickPageNumber = (pageNum) => {
        setpage((pageNum.selected + 1).toString())
    }

    useLayoutEffect(() => {
        getSettlementdetails();
    }, [page])


    /**
     * The function `updateHandler` is an asynchronous function that handles updating status and status
     * note for settlements, with error handling and state updates.
     * @returns The `updateHandler` function returns either nothing (undefined) or an error message if
     * an error occurs during the execution of the function.
     */
    const updateHandler = async () => {
        if (status?.trim() === '') {
            return;
        }
        if (note.trim().length > 500) {
            setNoteError('Description too long. Max 500 characters.');
            return;
        }

        try {
            const body = {
                status,
                status_note : note.trim()
            }
            setUpdateLoading(true);
            const response = await dataService.PatchAPI(body, `settlements/${cycleId}`)
            if (!response.error) {
                setmodalpopup(prevState => {
                    return { ...prevState, open: false }
                })
                setStatus('');
                setNote('');
                getSettlementdetails();
                setToastmessage('Status updated successfully');
            }
            setUpdateLoading(false);
        } catch (error) {
            setUpdateLoading(false);
            setmodalpopup(prevState => {
                return { ...prevState, open: false }
            })
            setStatus('');
            setNote('');
            getSettlementdetails();
            setToastError(error?.response?.data?.error);
            console.log(error)

        }
    }

    /**
     * The function `handleExport` sets loading state, fetches data from an API endpoint, opens a new
     * window with the fetched URL, and displays a success message upon successful export.
     */
    const handleExport = async () => {
        try {
            setExportloading(true);
            const res = await dataService.GetAPI(`orders/export-csv?settlements=true&settlement_currency=HKD&payment_status=Completed&create_start=${details?.cycle_start_date}&create_end=${details?.cycle_end_date}&store_email_address=${encodeURIComponent(details?.store_email_address)}`)
            if (!res.error) {
                if (!res.data.url) {
                    setToastError('No data to export');
                    setExportloading(false)
                    return;
                }
                window.open(
                    res.data.url,
                    '_blank'
                );
                // window.location.href = res.data.url
                setToastmessage('Transaction details exported successfully');
                setExportloading(false)
            }
        } catch (error) {
            setToastError('An Error Occured!');
            setExportloading(false);

        }
    }
    const hasChangeSettlement = checkPrivilege('change_settlement_status')

    return (
        /* The above code is a snippet of JavaScript React code that is creating a card component for
        displaying Crypto Settlement details. Here is a breakdown of what the code is doing: */
        <CardHeaders
            header="Settlements"
            back={-1}
        >
            <div className='bg-[#F5F5F5] px-4 py-[14px] relative  overflow-hidden'>
                <LoadingOverlay active={dataLoading === true} spinner text="Fetching settlement details...">
                    <div className='bg-white px-6 w-full h-customh12 overflow-y-auto scrollBar'>
                        <div>
                            <h1 className='font-playfair font-semibold text-[#4B4B4B] text-xl mt-[31px]'>Settlements</h1>
                        </div>
                        <div>
                            <h1 className='font-playfair font-semibold text-[#4B4B4B] text-xl mt-[36px]'
                                data-testid="settlement-details">Settlement Details</h1>
                        </div>

                        <div className='mt-6 w-full'>
                            <div className='w-[75%] flex'>
                                <div className='w-1/3'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Settlement Cycle ID</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="transaction-id">{details?.settlement_cycle_id || '-'}</p>
                                </div>
                                <div className='w-1/3'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2' >Merchant Name</p>
                                    <p
                                        data-testid="merchant-name"
                                        className='text-[647354] text-sm font-semibold 
                                        w-full overflow-hidden text-ellipsis whitespace-nowrap'
                                        title={details?.merchant_name}>
                                        {details?.merchant_name || '-'}
                                    </p>
                                </div>
                                <div className='w-1/3'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Store Name</p>
                                    <p
                                        className='text-[647354] text-sm font-semibold
                                            w-full overflow-hidden text-ellipsis whitespace-nowrap'
                                        title='hello'
                                        data-testid="store-name"
                                    >{details?.store_name || '-'}</p>
                                </div>
                            </div>
                            <div className='w-[100%] flex mt-6'>
                                <div className='w-1/4'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Cycle Start Date</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="cycle-start-date">{convertToDate(details?.cycle_start_date) || '-'}</p>
                                </div>
                                <div className='w-1/4'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Cycle End Date</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="cycle-end-date">{convertToDate(details?.cycle_end_date) || '-'}</p>
                                </div>
                                <div className='w-1/4'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Fees</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="fees">{`${details?.currency?.symbol || '-'}${details?.settlement_fees.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                                </div>
                                <div className='w-1/4'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Total Revenue</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="total-revenue">{`${details?.currency?.symbol || '-'}${details?.total_amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                                </div>
                            </div>
                            <div className='w-[100%] flex mt-6 items-start'>
                                <div className='w-1/4'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Amount</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="settlement-amount">{`${details?.currency?.symbol || '-'}${details?.settlement_amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                                </div>
                                <div className='w-1/4'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Settlement Currency</p>
                                    <p className='text-[647354] text-sm font-semibold' data-testid="settlement-currency">{details?.currency?.code || '-'}</p>
                                </div>
                                <div className='w-2/4'>
                                    <p c className="text-sm font-normal text-[#4B4B4B] text-left mb-1.5 flex gap-[10px]">
                                        Status
                                        {hasChangeSettlement && <img data-tooltip-id='status'
                                            data-testid="edit-status"
                                            src={`/assets/images/Support Edit.svg`}
                                            className={`${details?.status === 'Settled' ? 'cursor-not-allowed' : ''}`}
                                            alt='Edit'
                                            onClick={() => {
                                                if (details?.status === 'Settled') {
                                                    return
                                                }
                                                else {
                                                    setNoteError('')
                                                    setmodalpopup({
                                                        open: true,
                                                        options: ['Settled', 'Unsettled', 'Processing'],
                                                        title: 'Change Status'
                                                    })
                                                }
                                            }}
                                        />}
                                        {details?.status !== 'Settled' && <Tooltip
                                            id='status'
                                            place="right"
                                            content='Change Status'
                                        />}
                                    </p>

                                    <p className='text-[647354] text-sm font-semibold' data-testid="status">{details?.status || '-'}</p>

                                </div>

                            </div>
                            <div className='w-[100%] flex mt-6'>
                                <div className='w-[50%]'>
                                    <p className='font-normal text-sm text-[#4B4B4B] mb-2'>Status Note</p>
                                    <p className='text-[647354] text-sm font-semibold 
                                        break-words pr-2 text-justify h-[44px] scrollBar overflow-y-auto' data-testid="status-note"
                                        
                                    >
                                        {details?.status_note || '-'}</p>
                                </div>

                            </div>
                        </div>
                        <div className='flex justify-between mt-[36px]'>
                            <h1 className='font-playfair font-semibold text-[#4B4B4B] text-xl '>Transaction Details</h1>
                            <div className='w-fit pr-3 items-center'>
                                <Button
                                    classKey={`font-400 text-[14px] w-[70px] h-[32px] leading-[22px] px-[16px] py-[5px] 
                                border border-[#9E2064] text-primary rounded-[12px] relative`} // px-6 py-[8px] rounded-[16px]
                                    text="Export"
                                    disabled={exportloading}
                                    type="button"
                                    handleClick={handleExport}
                                    testId="export-btn"
                                    color="#9E2064"
                                    loading={exportloading}
                                    smallLoader={true}
                                />
                            </div>

                        </div>
                        <div className='mt-6 px-4 border border-[#EB9DC7] py-[16px] rounded mb-3'>
                            <div className="overflow-x-scroll scrollBar">
                                <table className="w-full pr-5 bg-white ">
                                    {transactionDetails && transactionDetails?.length > 0 && <thead className='sticky top-0 bg-white z-[9]'>
                                        <tr>
                                            <th className=" text-left px-3  min-w-[100px]">
                                                <span className="text-sm font-normal text-[#4B4B4B] ">
                                                    Order Number
                                                </span>
                                            </th>
                                            <th className='text-left px-3  min-w-[100px]'>
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Order Date
                                                </span>
                                            </th>
                                            <th className='text-left px-3  min-w-[100px]'>
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Payment Date
                                                </span>
                                            </th>
                                            <th className=" text-left px-3 min-w-[110px] ">
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Payment Type
                                                </span>
                                            </th>
                                            <th className="text-left px-3 min-w-[110px] ">
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Crypto Currency
                                                </span>
                                            </th>
                                            <th className=" text-right px-3 min-w-[110px] ">
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Order Amount
                                                </span>
                                            </th>
                                            <th className="text-right px-3 min-w-[100px] ">
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Fees
                                                </span>
                                            </th>
                                            <th className="text-right px-3 min-w-[100px] ">
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Payable
                                                </span>
                                            </th>
                                            <th className="text-left px-3 min-w-[150px] ">
                                                <span className='text-sm font-normal text-[#4B4B4B] '>
                                                    Currency
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>}

                                    <tbody>
                                        {transactionDetails && transactionDetails.map((item, i) => (
                                            <tr key={i}>
                                                <td className="px-3 py-3 whitespace-nowrap break-words bg-white min-w-[125px]">
                                                    <p class="break-words w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[100px] overflow-hidden text-ellipsis"
                                                        data-testid={`order-id-${i}`}
                                                    >{item?.order_id || '-'}</p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-left">
                                                    <p class="w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[100px] overflow-hidden text-ellipsis "
                                                        data-testid={`order-date-${1}`}
                                                    >{convertToDate(item?.created_at) || '-'}</p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-left">
                                                    <p class="w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[100px] overflow-hidden text-ellipsis "
                                                        data-testid={`order-date-${1}`}
                                                    >{convertToDate(item?.payment_date) || '-'}</p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-left">
                                                    <p
                                                        data-testid={`order-payment-type-${i}`}
                                                        class="w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[110px] overflow-hidden text-ellipsis ">{(item?.payment_type?.split(' ').slice(0, 2).join(' ') || '-')}</p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-left">
                                                    <p class="break-words w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[110px] overflow-hidden text-ellipsis">{(item?.crypto_coin || '-')}</p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-right">
                                                    <p class="break-words w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[110px] overflow-hidden text-ellipsis"
                                                        data-testid={`order-amount-${i}`}
                                                    >{`${item?.currency?.symbol || '-'}${item?.order_amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-right">
                                                    <p class="break-words w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[100px] overflow-hidden text-ellipsis"
                                                        data-testid={`order-fees-${i}`}
                                                    >
                                                        {`${item?.currency?.symbol || '-'}${Number(item?.commission)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 0.00} `}
                                                    </p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-right">
                                                    <p class="break-words w-full text-[14px] leading-[22px] font-semibold text-[#1F1F1F] min-w-[100px] overflow-hidden text-ellipsis"
                                                       
                                                    >
                                                        {`${item?.payable ? `${item?.currency?.symbol || '-'}${item?.payable?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-'}`}
                                                    </p>
                                                </td>
                                                <td className="px-3 whitespace-nowrap break-words text-left">
                                                    <p class="break-words w-full text-[14px] leading-[22px] font-semibold text-[#4B4B4B] max-w-[150px] overflow-hidden text-ellipsis"
                                                        data-testid={`order-settlement-currency-${i}`}
                                                    >
                                                        {item?.currency?.code || '-'}
                                                    </p>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                                {!dataLoading && transactionDetails?.length === 0 && (<div className='w-full flex justify-center'><EmptyPage text='No transactions available yet' /></div>)}
                            </div>

                            {!dataLoading && Math.ceil(totalCount / 10) > 1 && !(transactionDetails?.length === 0) &&
                                <Pagination
                                    selectedPageNumber={page}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    TotalCount={totalCount}
                                    totalPageNumber={Math.ceil(totalCount / 10)}
                                />}
                        </div>

                    </div>
                </LoadingOverlay>
            </div>
            <ModalBox
                open={modalpopup.open}
                title={modalpopup.title}
                options={modalpopup.options}
                setmodalpopup={setmodalpopup}
                setValue={setStatus}
                selectedValue={status}
                setNote={setNote}
                note={note}
                onUpdate={updateHandler}
                isLoading={updateLoading}
                noteError={noteError}
                setNoteError={setNoteError}
                staticStatus={staticStatus}
                onCloseFunction={getSettlementdetails}
            />
        </CardHeaders>
    )
}
